"use strict";

function formPush(event, formType, formStep, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formItemPush(event, formType, formStep, stepType, itemName) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPeoplePush(event, formType, formStep, stepType, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPlansPush(event, formType, formStep, stepType, numberPlans) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            numberPlans : numberPlans,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function quoteCompletePush(event, formType, formStep, peopleCovered, member, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            peopleCovered : peopleCovered,
            member : member,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function healthPMIQuoteCompletePush(event, formType, formStep, stepType, itemName, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function memberItemPush(event, formType, formStep, stepType, itemName, member) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            member : member
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function ecommercePush(event, formType, formStep, stepType, peopleCovered, itemCategory, ecommerce) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
            itemCategory : itemCategory,
            ecommerce : ecommerce
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function internationalDestinationPush(event, formType, formStep, stepType, itemName, destination) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            destination : destination
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formAddOnsPush(event, formType, formStep, stepType, addOns) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            addOn : addOns
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function intReviewPush(event, formType, formStep, stepType, itemName, addOns, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            addOn : addOns,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

module.exports = {
    formPush: formPush,
    formItemPush: formItemPush,
    formPeoplePush : formPeoplePush,
    formPlansPush : formPlansPush,
    quoteCompletePush: quoteCompletePush,
    healthPMIQuoteCompletePush: healthPMIQuoteCompletePush,
    memberItemPush: memberItemPush,
    ecommercePush: ecommercePush,
    internationalDestinationPush: internationalDestinationPush,
    formAddOnsPush: formAddOnsPush,
    intReviewPush: intReviewPush
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/analyticsUtil.js
// module id = 0v5J
// module chunks = 0 1 2 3 5 6 9 10 11 12 13 14